// Phase 2 — semantic icon size tokens
//
// Currently icon dimensions are hardcoded across components with no token system.
// This file will provide a named size scale once confirmed with design
// (see FIGMA_DESIGN_SYSTEM_UPDATES.md Part 7.2).
//
// Proposed scale (pending design confirmation):
//
//   xs   12px  — inline icons in labels, badges
//   sm   16px  — inline action icons, list row icons
//   md   20px  — standard button icons (most common)
//   lg   24px  — hero icons, navigation icons
//   xl   32px  — feature icons, empty state illustrations
//
// Note: iconSize values are theme-independent.
// Will be a separate primitive export, not part of semanticTokens color object.

export const iconSize = {} as const

export type IconSize = typeof iconSize
